module.exports = __webpack_public_path__ + "img/logout.6ef02cfb.svg";